import { Button } from 'components/common/Buttons/Button'
import { Container } from 'components/common/Containers/Container/Container'
import { Flex } from 'components/common/Containers/Flex/Flex'
import { FlexColumn } from 'components/common/Containers/FlexColumn/FlexColumn'
import { H2 } from 'components/common/Texts/H2/H2'
import React from 'react'
import styles from './Invest.module.scss'
import Upgrade from './svgs/upgrade.svg'

interface Props {
}

const Invest: React.FC<Props> = ({}) => {
  return (
    <Flex className={styles.investWrap}>
      <Container className={styles.content}>
        <FlexColumn justify="center" align="center">
          <Upgrade/>
        </FlexColumn>
        <FlexColumn className={styles.contentWrap}>
          <H2>Let us show you the world of domain investing.&lsquo;</H2>
          <p>
          The world of domain investing is waiting for you. 
          With the right tools for domain appraisal and domain value checker, 
          you can learn how to use the potential of domains to become valuable assets. 
          </p>
          <p>
          Having a hard time choosing the right domain name? Use our domain name valuation tools, such as domain SEO check and domain age checker, to make the right decisions.
          </p>
          <p>
          The right domain names are available for sale every day. We&apos;ll help you find them fast, so you can just concentrate on doing your business.
          </p>
          <Button>I am ready to sign-up!</Button>
        </FlexColumn>
      </Container>
    </Flex>
  )
}


export default Invest
